import React from 'react';

function TitleWithListOfImages({accentColor, title, backgroundColor, items}) {
  return (
    <section className={'pt-16 lg:pt-44 pb-5 lg:pb-24 px-5 sm:px-7 lg:px-20'} style={{ backgroundColor: backgroundColor }}>
      <h6 className={`relative w-3/4 pb-6 lg:pb-12 text-5xl sm:text-7xl lg:text-9xl font-bold font-comp uppercase`} style={{ color: accentColor}}>
        {title}
        <span className={'absolute bottom-0 left-0.5 w-11 sm:w-93px lg:w-52 h-1 sm:h-5px lg:h-2.5'} style={{ backgroundColor: accentColor}}></span>
      </h6>
      <ul className={'flex flex-wrap justify-start lg:justify-center justify-items-center mt-14 sm:mt-20 lg:my-28 gap-y-12 sm:gap-y-16 gap-x-11 sm:gap-x-24 lg:gap-28 pl-0 sm:pl-7 lg:pl-0 font-sans text-base-color text-xl'}>
        {items.map((item, idx) => {
          const { image: pic, position, title } = item.fields;
            return (
              <li className={'flex flex-col text-center'} key={idx}>
                  <img
                    src={pic?.fields.file.url}
                    alt={pic?.fields.title}
                    style={{borderColor: accentColor}}
                    className={'w-28 xs:w-36 sm:w-52 h-28 xs:h-36 sm:h-52 border-3 sm:border-4 rounded-full object-center bg-white mb-7'}
                  />
                  <h3 className={'font-bold font-comp'}>{title}</h3>
                  <p>{position}</p>
              </li>
            )
        })}
      </ul>
    </section>
  );
}

export default TitleWithListOfImages;
